import * as React from 'react';
import { connect } from 'react-redux';
import KPSelectableList from '../../SSPCustomComponentLibrary/KPSelectableList/KPSelectableList';
import { ISelectableList, ISelectableListItem } from '../../../../interfaces/KPSelectableList/KPSelectableListInterfaces';
import './KPSelectableListPage.css';
import '../../StylingProjectMain.css';

class KPSelectableListPage extends React.Component<any, any> {
    selectableListComponent: React.RefObject<KPSelectableList>;

    constructor(props) {
        super(props);

        this.state = {
            mode: "checkboxGroup",
            items: [],
            radioGroup: false,
            autosize: false,
            selectLeft: true,
            selectedItems: []
        };

        this.selectableListComponent = React.createRef();
        this.getTestDataSet = this.getTestDataSet.bind(this);
        this.loadListItems = this.loadListItems.bind(this);
        this.handleToggleDisplay = this.handleToggleDisplay.bind(this);
        this.handleSwitchMode = this.handleSwitchMode.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
    }

    componentDidMount() {
        this.loadListItems();    
    }

    loadListItems() {
        let dataSet = this.getTestDataSet();
        if (this.selectableListComponent?.current != null) {
            this.selectableListComponent.current.setList(dataSet);
        }
    }

    handleToggleDisplay(e: any) {
        let name = e.target.value;
        let checked = e.target.checked;
        this.setState({ [name]: checked }, () => {
            if (name === "selectLeft") {
                this.loadListItems();
            }
        });
    }

    handleSwitchMode(e: any) {
        this.setState({
            mode: e.target.value,
            radioGroup: (e.target.value === "radioGroup")
        });
    }

    handleItemSelect(id: string, selected: boolean) {
        if (this.selectableListComponent?.current != null) {
            let selectedItems = this.selectableListComponent.current.getSelection();
            this.setState({selectedItems});
        }
    }

    getTestDataSet(): ISelectableListItem[] {
        let dataSet: ISelectableListItem[] = [];
        for (let i = 1; i <= 10; i++) {
            let value = "item" + i;
            let item: ISelectableListItem = {
                id: value,
                value: value,
                label: value + " Some long text that will need to wrap as it becomes too long.",
                selected: false,
                required: false,
                disabled: false,
                handleSelect: null,
                selectOnLeft: this.state.selectLeft,
                className: ""
            }
            dataSet.push(item);
        }
        return dataSet;
    }

    public render() {
        let selectedItems: any = <></>;
        if (this.state.selectedItems && this.state.selectedItems.length > 0) {
             selectedItems = this.state.selectedItems.map((item) => {
                return <li>{item.value}</li>
            })
        }

        return (
            <div id="appContainer" className="noProfile styling-project">
                <div className="styling-foundation-page-header">
                    SSP KP Selectable List Component
                </div>
                
                <div className="row pl-4 pr-4">
                    <div className="col-md-6 styling-project-mode-panel">
                        <h4>Switch Mode</h4>
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="radCheckGroup" className="radio-text text-center">
                                    <input
                                        type="radio"
                                        id="radCheckGroup"
                                        value="checkboxGroup"
                                        checked={this.state.mode === "checkboxGroup"}
                                        onChange={this.handleSwitchMode}
                                        className="check"
                                    />
                                    Checkbox
                                </label>
                            </div>

                            <div className="col-6">
                                <label htmlFor="radRadioGroup" className="radio-text text-center">
                                    <input
                                        type="radio"
                                        id="radRadioGroup"
                                        value="radioGroup"
                                        checked={this.state.mode === "radioGroup"}
                                        onChange={this.handleSwitchMode}
                                        className="check"
                                    />
                                    Radio
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 styling-project-mode-panel">
                        <div>
                            <h4>Toggle display style</h4>
                            <div>
                                <label htmlFor="chkAutosize" className="radio-text text-center">
                                    <input
                                        type="checkbox"
                                        id="chkAutosize"
                                        value="autosize"
                                        className="check"
                                        checked={this.state.autosize}
                                        onChange={this.handleToggleDisplay}
                                    />
                                    Auto Size
                                </label>
                            </div>

                            <div>
                                <label htmlFor="chkSelectLeft" className="radio-text text-center">
                                    <input
                                        type="checkbox"
                                        id="chkSelectLeft"
                                        value="selectLeft"
                                        className="check"
                                        checked={this.state.selectLeft}
                                        onChange={this.handleToggleDisplay}
                                    />
                                    Select On Left Side
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="styling-foundation-input-container-large mt-4" style={{ width: "unset" }}>
                    <div className="row">
                        <div className="col-md-6">
                            <KPSelectableList
                                ref={this.selectableListComponent}
                                items={this.state.items}
                                radioGroup={this.state.radioGroup}
                                handleSelect={this.handleItemSelect}
                                autosize={this.state.autosize}
                            />
                        </div>
                        <br />

                        <div className="col-md-6">
                            <h4>Selected Items</h4>
                            <div>
                                <ul>
                                    {selectedItems}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return { }
}

export default connect(mapStateToProps, mapDispatchToProps)(KPSelectableListPage)